import { render, staticRenderFns } from "./WaitingForPayDetail.vue?vue&type=template&id=3bbee61d&scoped=true&"
import script from "./WaitingForPayDetail.vue?vue&type=script&lang=js&"
export * from "./WaitingForPayDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaitingForPayDetail.vue?vue&type=style&index=0&id=3bbee61d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbee61d",
  null
  
)

export default component.exports